module["exports"] = [
  "####-#####",
  "####-######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sv/phone_number/formats.js
// module id = 2756
// module chunks = 2